import {SELECT_INSTALLMENT_TYPE} from '../actionTypes'


export default function (state = null, action) {
    //console.log(action.type);
    //console.log(action.payload);
    switch (action.type) {
        case SELECT_INSTALLMENT_TYPE:
            //console.log(action.payload)
            return action.payload
    }

    return state;
}